export default __webpack_public_path__ + "static/media/home-travel-agency-tour-intrest-img04.95c55f17.jpg";